import Tvm from './Tvm';

function App() {
  return (
    <div className="container mx-auto font-mono">
      <div className="mx-auto max-w-2xl my-8">
        <Tvm />
      </div>
    </div>
  );
}

export default App;
